<template>
  <div class="ptb15 borderBottom listItem">
    <div class="mb10 cl333 f14 font-bold discolour" @click="detailsClick">
      {{ item.title }}
    </div>
    <div class="mb15 cl666 f13 listItem-description">
      {{ item.sub }}
    </div>
    <div class="cl999 f13">{{item.date}}</div>
  </div>
</template>
<script>
export default {
  name: "listItem",
  props: {
    item: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {}
  },
  mounted() {

  },
  methods: {
    detailsClick() {
      this.$emit('detailsClick')
    }
  }
}
</script>
<style scoped lang="scss">
.listItem {
  &-description {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
  }
}
</style>
